import { createRouter, createWebHistory } from 'vue-router';
import DefaultDashboard from '@/views/DefaultDashboard.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: DefaultDashboard,
  },
  {
    path: '/village/:id',
    name: 'Village',
    component: DefaultDashboard,
  },
  {
    path: '/village/:id/family/:familyId',
    name: 'Family',
    component: DefaultDashboard,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
